import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["logos", "size", "gradientColor"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { Col, Image } from '@miro-site/ui-design-system';
import styles from './logo-ticker.module.scss';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var LogoRow = function LogoRow(_ref) {
  var logos = _ref.logos,
      size = _ref.size;
  var logoRow = logos.length < size ? Array.from({
    length: size
  }) : logos;
  return /*#__PURE__*/_jsx("div", {
    className: "d-flex gap-300 p-0 ".concat(styles.logos),
    children: logoRow.map(function (_, index) {
      var _logo$image;

      var logo = logos[index % logos.length];

      if (!(logo !== null && logo !== void 0 && (_logo$image = logo.image) !== null && _logo$image !== void 0 && _logo$image.src)) {
        return null;
      }

      return /*#__PURE__*/_jsx("div", {
        className: "d-flex justify-content-center align-items-center ".concat(styles.logo),
        children: /*#__PURE__*/_jsx(Image, {
          unoptimized: true,
          image: logo.image
        })
      }, index);
    })
  });
};

var CSSVariables = styled(Col).withConfig({
  displayName: "LogoTicker__CSSVariables",
  componentId: "sc-1uufdyo-0"
})(["", ""], function (props) {
  if (props.$gradientColor) {
    return "--logo-ticker-gradient-color-rgb: var(--wcds-colors-".concat(props.$gradientColor, "-rgb);");
  }

  return '';
});

var LogoTicker = function LogoTicker(_ref2) {
  var logos = _ref2.logos,
      size = _ref2.size,
      gradientColor = _ref2.gradientColor,
      rest = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/_jsxs(CSSVariables, _objectSpread(_objectSpread({
    className: "position-relative overflow-hidden d-flex flex-nowrap ".concat(styles.logoTicker),
    $gradientColor: gradientColor
  }, rest), {}, {
    children: [/*#__PURE__*/_jsx(LogoRow, {
      logos: logos,
      size: size
    }), /*#__PURE__*/_jsx(LogoRow, {
      logos: logos,
      size: size
    })]
  }));
};

export default LogoTicker;